import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import {unavailableReasonLabels} from "../../../../web/materials/maintenances/utils/maintenances-utils.jsx";
import {FaTriangleExclamation} from "react-icons/fa6";

const ReportContent = ({data, tableColumns}) => {

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Movimentações`, "material-movements-data");
    }, [data, tableColumns]);

    const getOperation = (value) => {
        switch (value) {
            case "acquisition":
                return "AQUISIÇÃO"
            case "decrease":
                return "BAIXA";
            case "maintenance_send":
                return "INDISPONIBILIDADE";
            case "maintenance_return":
                return "RETORNO DE INDISPONIBILIDADE";
            case "caution":
                return "CAUTELA";
            case "transfer":
                return "TRANSFERÊNCIA";
            case "caution_return":
                return "RETORNO DE CAUTELA";
            case "adjustment":
                return "AJUSTE";
            default:
                return "";
        }
    }

    const hasUnavailableReason = data.some((el) => String(el?.unavailable_reason ?? '').trim() !== '');
    const getObservation = (element) => {
        switch (element.operation){
            case 'caution_return': return element.final_observations ?? "";
            case 'maintenance_send': return element.note_send ?? "";
            case 'maintenance_return': return element.note_return ?? "";
            default: return element.observations ?? "";
        }
    };
    const columns = [
        {id: "date", label: "Data/Hora", className: "w-[11%]", renderCell: element => ReportUtils.formatDateTime(element.date)},
        {id: "requester", label: "Solicitante", className: "w-[9%]", renderCell: element => element.requester ?? ""},
        {id: "third_party_requester", label: "Entrega por terceiro", className: "w-[9%]", renderCell: element => element.third_party_requester ?? ""},
        {id: "responsible", label: "Almoxarife", className: "w-[9%]", renderCell: element => element.responsible ?? ""},
        {id: "storage", label: "Depósito", className: "w-[8%]", renderCell: element => `${element.storage ?? ""}${element.storage_destination ? " -> " + element.storage_destination : ""}`},
        {id: "group", label: "Grupo", className: "w-[8%]", renderCell: element => element.group ?? ""},
        {id: "material", label: "Material", className: "w-[9%]", renderCell: element => element.material ?? ""},
        {id: "quantity", label: "Qtd.", className: "w-[5%]", renderCell: element => element.quantity ?? ""},
        {id: "operation", label: "Operação", className: "w-[8%]", renderCell: element => getOperation(element.operation)},
        {id: "unavailable_reason", label: "Motivo", className: "w-[10%]", renderCell: element => unavailableReasonLabels[element.unavailable_reason ?? ""]},
        {id: "observation", label: "Observação", className: "w-[11%]", renderCell: getObservation},
        {id: "breakdown", label: "Avaria", className: "w-[10%]", renderCell: element => element.breakdown ?? ""}
    ];
    const availableColumns = columns.filter(column => column.id !== "unavailable_reason" || hasUnavailableReason);
    const visibleColumns = availableColumns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="material-movements-data" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Movimentações">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>

                <tbody className="bg-white">
                    {data.map((element, index) => (
                        <tr key={index}>
                            {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;